import { AxiosResponse } from 'axios'

export default class APIHelper {
  static extractData<T>(response: AxiosResponse): T {
    return response.data
  }

  static extractToken(data: { LoginSystemResult: { APIToken: string } }): string {
    return data.LoginSystemResult.APIToken.split(' ')[1]
  }
}
